export default "__VITE_ASSET__D7Rb4oTt__"